import axiosClient from "./axiosClient";
import {API_GET_REGION, PAGING_SIZE_DEFAULT} from "../service/apiConfig"
const PAGING_DEFAULT = PAGING_SIZE_DEFAULT
const provinceApi = {
    getRegionByIp: () =>{        
        return axiosClient.get(API_GET_REGION)
    },
    getProvinceNesrest: (data) =>{        
        const body = {
            ...data,
            page: 1,
            pageSize: PAGING_DEFAULT
        }
        const url = `api/province/getallnearest`
        return axiosClient.post(url, data)
    },
    searchById: (params, language) =>{
        const url = `api/province/${params}/${language}`
        return axiosClient.get(url)
    },
    getAll: (params, language) =>{
        const url = (params == null || params == '') ? `api/province/getall/${language}` : `api/province/getall/${params}/${language}`        
        return axiosClient.get(url)
    },
    getById: (params) =>{
        const url = `api/province/${params}`
        return axiosClient.get(url,params)
    },

    updateById: (params,data) =>{
        const url = `api/province/${params}`
        return axiosClient.put(url,data, {
            useAuthorize: true
        })
    },
    create: (data) =>{
        const url = `api/province/create`
        return axiosClient.post(url,data, {
            useAuthorize: true
        })
    },
    delete: (params) =>{
        const url = `api/province/${params}`
        return axiosClient.delete(url , {
            useAuthorize: true
        })
    },
    // getNearestProvince : (data) => {  
    //         const body = {
    //             ...data,
    //             page: 1,
    //             pageSize: PAGING_DEFAULT
    //         }
    // //     const json = {
    // //       longitude: longitude ,
    // //       latitude: latitude,
    // //       page: 1,
    // //       pageSize: PAGING_DEFAULT,
    // //       language: language,
    // //       allowIncludeCurrent: allowIncludeCurrent,
    // //    };
    //    const url = `api/province/getallnearest`
    //    return axiosClient.post(url, body)
    // //     return api.post(PREFIX_PROVINCES + GET_NEAREST, json, APIConfigHeader ).then((response) => { 
    // //       return response.data.data;
    // //     }).catch((err) => console.log('data ' +  err))
    //   }
}
export default provinceApi;